import { sendRequest } from './send-request';

const SERVICE_ACCOUNT_TYPE_MAP: Record<string, string> = {
  payAsYouGo: 'PAYG',
  payMonthly: 'PAYM',
  business: 'BUSINESS',
};

function buildPayload({ formData, recaptchaToken }: { formData: Record<string, any>, recaptchaToken: string }) {
  // NOSONAR
  return {
    formData: {
      contactInfo: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phoneNumber: formData.contactMobileNumber,
        address: {
          line1: formData.addressLine1,
          line2: formData.addressLine2 || '',
          townOrCity: formData.town,
          county: formData.country,
          postcode: formData.postCode,
        },
        preferredMethod: formData.preferContact,
      },
      accountInfo: {
        businessUnit: 'O2',
        o2: {
          msisdn: formData.mobileNumber,
          accountType: SERVICE_ACCOUNT_TYPE_MAP[formData.service] ?? 'BUSINESS',
          isNonCustomer: formData.isCustomer === 'no',
        },
        vm: {
          accountNumber: '',
        },
      },
      complaint: {
        parentCategory: formData.issueDescription,
        childCategory: formData.issueType,
        subject: formData.issueDetails,
        details: formData.issueDetails,
        resolution: formData.howToFixTheIssue,
      },
    },
    recaptcha: {
      token: recaptchaToken,
      siteKey: "",
    }
  };
}

export type ComplainFormRequestPayloadType = ReturnType<typeof buildPayload>;

export const sendComplaintsFormRequest = async ({ formData, recaptchaToken }: { formData: Record<string, any>, recaptchaToken: string }) => {
  return await sendRequest(buildPayload({ formData, recaptchaToken }));
};
